import { render, staticRenderFns } from "./Addnetworks.vue?vue&type=template&id=48157d3c&scoped=true"
import script from "./Addnetworks.vue?vue&type=script&lang=js"
export * from "./Addnetworks.vue?vue&type=script&lang=js"
import style0 from "./Addnetworks.vue?vue&type=style&index=0&id=48157d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48157d3c",
  null
  
)

export default component.exports